import React, {useRef, useState} from 'react'
import styled from 'styled-components'
import { ButttonWrap, FileUploadButton } from 'components/files/files.styled'
import { useDispatch, useSelector } from 'react-redux'
import SpinnerSmall from 'components/SpinnerSmall'
import { addQuestion } from 'features/qaSessions/qaSessionSlice'
import { useParams } from 'react-router-dom'
import toast from 'react-hot-toast'
import { pBtn } from 'components/main.styled'
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import { useTranslation } from 'react-i18next';

export default function AskAQuestionInput() {
    const { t } = useTranslation('qna')

    const dispatch = useDispatch()
    const textareaRef = useRef(null)
    const { user } = useSelector((state) => state.auth)
    const { addQuestionStatus, sessionData } = useSelector((state) => state.qASession)
    const { sessionId } = useParams()
    const [ isAnonymous, setIsAnonymous ] = useState(false)
 

    const handleAnonymous = () => {

        setIsAnonymous(!isAnonymous)
    }

    const handleSubmit = () => {

        if(textareaRef.current.value === ""){
            toast.error(t('emptyQuestionError'))
            return
        }

        dispatch(addQuestion({
            text: textareaRef.current.value,
            sessionId: sessionId,
            isAnonymous: isAnonymous,
        }))
        
        textareaRef.current.value = "" 
        toast.success(t('questions.submitted'))
    }

    return (
        <AskAQuestionWrap> 
            <UserInfoWrap
                
                > 
                {
                    isAnonymous ? 
                    (
                        <>
                            <NoAccountsIcon  style={{fontSize:"36px", color: "#585858"}}/>
                            <NameInfo style={{marginTop: "3px"}}>Anonymous</NameInfo>
                        </>
                    )
                    :
                    (
                        <>
                            <img
                                style={{height: "35px", width: "35px", borderRadius: "50%"}}
                                src={user.imagePath}
                                alt='user'
                                />          
                            <NameInfo>{user.fullName}</NameInfo>
                        </>
                    )
                }

            </UserInfoWrap>
            <StyledInput ref={textareaRef} /> 
            <ButttonWrap style={{ justifyContent: 'space-between'}}>
                <AnonymousButton
                    style={{visibility: sessionData.allowAnonymous ? "visible": "hidden"}}
                    onClick={handleAnonymous}
                    >
                    {
                        isAnonymous ? 
                        ( "Share Name" )
                        :
                        ( "Ask Anonymously" )
                    }
                </AnonymousButton>
                <FileUploadButton
                    disabled={addQuestionStatus === "LOADING"}
                    onClick={handleSubmit} 
                    >
                    {
                        addQuestionStatus === "LOADING" ?
                        ( <SpinnerSmall /> )
                        :
                        ( "Submit Question" )
                    }
                </FileUploadButton>
            </ButttonWrap> 
        </AskAQuestionWrap>
    )
}

const NameInfo = styled.div`
    font-size: 14px;
    color: var(--lightThemeFontColor);
    font-weight: 600;
`

const UserInfoWrap = styled.div`
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 10px;
    margin-bottom: 10px;
`

const AnonymousButton = styled(pBtn)`
    background-color: #f2f6f8;
    border: 1px solid #e1e7eb;
    color: #626b70;
    border-radius: 7px;
    font-weight: 600;

    &:hover{
        background-color: #eef1f3;
    }
`

const StyledInput = styled.textarea.attrs({
  type: 'text', 
  placeholder: 'Enter your question here...', 
})`
    resize: none; 
    background-color: #fbfcfd;
    width: 100%;
    min-height: 160px;
    outline: none;
    border: 1px solid #dfe7ec;
    border-radius: 8px;
    font-family: "Roboto";
    font-size: 15px;
    padding: 14px;
    color: var(--lightThemeFontColor);
    transition: 0.25s;

    &:focus{
        border-color: #21ad46;
        box-shadow: 0 0 0 3px rgba(33, 173, 70, 0.12);
    }
`

const AskAQuestionWrap = styled.div`
    padding: 18px;
    border-radius: 8px;
    background-color: white;
    font-family: "Roboto";
    border: 1px solid #edf0f2;
    box-shadow: 0 4px 16px rgba(61, 70, 78, 0.10);
    display: flex;
    flex-direction: column;
    width: 100%;
    height: fit-content;
    margin-top: 20px; 

    @media (max-width: 768px) {
        margin-top: 10px;
    }
 

`
